
const translations = {
  // Navigation
  "nav.about": "Chi Siamo",
  "nav.business": "Attività",
  "nav.recruitment": "Lavora con Noi",
  "nav.contact": "Contatti",

  // Hero Section
  "hero.title1": "Materiali tessili di alta qualità",
  "hero.title2": "Dal Giappone al mondo",
  "hero.subtitle1": "Dal 2006, qualità e fiducia affidabili",
  "hero.subtitle2": "Business diretto con brand globali",
  "hero.cta": "Scopri le nostre attività",

  // About Section
  "about.label": "Chi siamo",
  "about.title": "Profilo aziendale",
  "about.description1": "SECOND CO., LTD è stata fondata nel 2006 come azienda specializzata nell'esportazione di materiali tessili. Dalla nostra fondazione, abbiamo costruito rapporti di fiducia con i clienti esteri attraverso la fornitura di prodotti e servizi di alta qualità.",
  "about.description2": "Ci concentriamo su materiali tessili e prodotti di filato, lavorando con i nostri clienti sulla pianificazione e lo sviluppo, realizzando il 100% delle esportazioni all'estero. Il nostro punto di forza risiede nei rapporti diretti con i marchi in Europa, in particolare in Italia e Francia.",
  "about.description3": "Abbiamo stabilito un sistema di fornitura stabile e di alta qualità, con piena conformità alla tracciabilità e alla documentazione relativa alla qualità, garantendo ai nostri clienti un utilizzo in tutta sicurezza.",
  "about.companyName": "Nome azienda",
  "about.companyNameValue": "SECOND CO., LTD",
  "about.englishName": "Nome inglese",
  "about.englishNameValue": "SECOND CO., LTD",
  "about.established": "Fondata",
  "about.establishedValue": "17 novembre 2006",
  "about.representative": "Rappresentante",
  "about.representativeValue": "CEO Hiromi Nonogaki",
  "about.capital": "Capitale",
  "about.capitalValue": "8 milioni di yen",
  "about.employees": "Dipendenti",
  "about.employeesValue": "4",
  "about.address": "Indirizzo",
  "about.addressValue1": "2-7-14 Omiya, Ichinomiya,",
  "about.addressValue2": "Prefettura di Aichi, Giappone",
  "about.phone": "Telefono",
  "about.phoneValue": "+81-586-25-4180",

  // Business Section
  "business.label": "Attività",
  "business.title": "Le nostre attività",
  "business.planning.title": "Pianificazione e vendita materiali",
  "business.planning.description": "Dalla pianificazione alla vendita di vari filati e materiali, forniamo proposte su misura per le esigenze dei clienti. Siamo specializzati nella pianificazione, presentazione e vendita di materiali tessili sul mercato europeo.",
  "business.export.title": "Operazioni di esportazione",
  "business.export.description": "100% esportazione all'estero, con un sistema di fornitura stabile principalmente verso l'Europa (Italia, Francia). Realizziamo affari diretti con i marchi.",
  "business.quality.title": "Controllo qualità",
  "business.quality.description": "Piena conformità con la tracciabilità e la documentazione relativa alla qualità. Manteniamo un rigoroso sistema di controllo qualità per consegnare prodotti di alta qualità con fiducia.",

  // Recruitment Section
  "recruitment.label": "Reclutamento",
  "recruitment.title": "Carriere",
  "recruitment.subtitle": "Unisciti al nostro team",
  "recruitment.position": "Export e operazioni commerciali",
  "recruitment.jobTitle": "Posizione",
  "recruitment.jobTitleValue": "Operazioni di esportazione, Amministrazione commerciale",
  "recruitment.employmentType": "Tipo di impiego",
  "recruitment.employmentTypeValue": "Tempo pieno o part-time",
  "recruitment.workingHours": "Orario di lavoro",
  "recruitment.workingHoursValue": "10:00 - 18:00",
  "recruitment.location": "Sede",
  "recruitment.locationValue": "2-7-14 Omiya, Ichinomiya, Aichi, Giappone",
  "recruitment.howToApply": "Come candidarsi",
  "recruitment.howToApplyValue": "Contattateci via email",
  "recruitment.atmosphere": "Ambiente di lavoro",
  "recruitment.atmosphere1": "Un ambiente dove molte donne sono attive",
  "recruitment.atmosphere2": "Codice di abbigliamento flessibile (purché ordinato)",
  "recruitment.atmosphere3": "Orari di lavoro rilassati con inizio alle 10:00",

  // Contact Section
  "contact.label": "Contatti",
  "contact.title": "Contattaci",
  "contact.company": "Nome azienda",
  "contact.name": "Il tuo nome",
  "contact.email": "Indirizzo email",
  "contact.message": "Messaggio",
  "contact.submit": "Invia messaggio",
  "contact.submitting": "Invio in corso...",
  "contact.success": "Grazie per la tua richiesta. Abbiamo ricevuto il tuo messaggio.",
  "contact.error": "Invio fallito. Riprova.",
  "contact.characters": "caratteri",

  // Footer
  "footer.companyInfo": "Informazioni",
  "footer.contact": "Contatti",
  "footer.businessHours": "Orari di apertura",
  "footer.weekday": "Lun-Ven 10:00-18:00",
  "footer.holiday": "Chiuso nei weekend e festivi",
  "footer.description": "SECOND CO., LTD\nConsegniamo materiali tessili\ndi qualità in tutto il mondo",
  "footer.copyright": "© 2006-2025 SECOND CO., LTD. Tutti i diritti riservati."
};

export default translations;
